import { useEffect, useState } from 'react';

/** Milliseconds elapsed since `startedAtIso`, ticking once a second; null for missing/invalid input. */
export function useElapsedMs(startedAtIso: string | null | undefined): number | null {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!startedAtIso) return;
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, [startedAtIso]);
  if (!startedAtIso) return null;
  const startedAt = new Date(startedAtIso).getTime();
  if (Number.isNaN(startedAt)) return null;
  return now - startedAt;
}
